export const modeCursorGet = (modeIsSelect: boolean): string => {
  return modeIsSelect ? "pointer" : "auto";
};
